import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { ReactComponent as SearchIcon } from 'assets/ss-icons/search.svg';
// import { ReactComponent as CloseIcon } from 'assets/img/icons/close.svg';

export default function TableSearch({
  inputRef = null,
  value = '',
  disabled = false,
  placeholder = 'Search',
  onChange = () => {},
  onCancel = () => {},
  className = '',
  containerClassName = '',
  searchIconClassName = '',
  cancelIconClassName = '',
  ...inputProps
}) {
  return (
    <UiKit.Input
      inputRef={inputRef}
      value={value}
      onChange={value => onChange(value)}
      disabled={disabled}
      placeholder={placeholder}
      className={containerClassName}
      inputClassName={cn(styles.input, className)}
      inputWrapperClassName={styles.inputWrapper}
      aria-label="Search"
      {...inputProps}
    >
      <div className={cn(styles.icon, styles.searchIcon, searchIconClassName)}>
        <SearchIcon />
      </div>
      {/* <div
        className={cn(
          styles.icon,
          styles.crossIcon,
          {
            [styles.show]: !!value,
            [styles.disabled]: disabled
          },

          cancelIconClassName
        )}
        onClick={onCancel}
      >
        <CloseIcon />
      </div> */}
    </UiKit.Input>
  );
}
